const TrashIcon = (props: any) => {
  return (
    <svg
      width={props.width}
      height={props.height}
      viewBox='0 0 17 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <g filter='url(#filter0_b_38_230)'>
        <path
          d='M11 5H13.5V6H12.5V12.5C12.5 12.7761 12.2761 13 12 13H5C4.72386 13 4.5 12.7761 4.5 12.5V6H3.5V5H6V3.5C6 3.22386 6.22386 3 6.5 3H10.5C10.7761 3 11 3.22386 11 3.5V5ZM11.5 6H5.5V12H11.5V6ZM9.2071 8.99985L10.091 9.88375L9.3839 10.5908L8.5 9.70695L7.6161 10.5908L6.90901 9.88375L7.7929 8.99985L6.90901 8.116L7.6161 7.4089L8.5 8.29275L9.3839 7.4089L10.091 8.116L9.2071 8.99985ZM7 4V5H10V4H7Z'
          fill='#6F6C8F'
        />
      </g>
      <defs>
        <filter
          id='filter0_b_38_230'
          x='-53.8656'
          y='-54.3656'
          width='124.731'
          height='124.731'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feGaussianBlur in='BackgroundImageFix' stdDeviation='27.1828' />
          <feComposite
            in2='SourceAlpha'
            operator='in'
            result='effect1_backgroundBlur_38_230'
          />
          <feBlend
            mode='normal'
            in='SourceGraphic'
            in2='effect1_backgroundBlur_38_230'
            result='shape'
          />
        </filter>
      </defs>
    </svg>
  );
};

export default TrashIcon;
